import { useEffect } from 'react'

import { RequestStatus } from 'core/domain/Request'
import { Section } from 'core/ui/components/section/Section'
import { useAbortController } from 'core/ui/hooks/useAbortController'

import analytics from 'legacy/utils/analytics'

import { useSpotQuoteList } from './hooks/useSpotQuoteList'
import { SpotQuoteCard } from './SpotQuoteCard'
import { SpotQuoteListRefreshBanner } from './SpotQuoteListRefreshBanner'

export type SpotQuoteListProps = {
  onChange?: (count: number) => {}
}

export function SpotQuoteList({ onChange }: SpotQuoteListProps) {
  const abortController = useAbortController()
  const { spotQuoteList, spotQuoteListStatus, fetchSpotQuoteList } = useSpotQuoteList()

  const hasError = spotQuoteListStatus === RequestStatus.Error

  useEffect(() => {
    fetchSpotQuoteList(abortController)
  }, [abortController, fetchSpotQuoteList])

  useEffect(() => {
    if (!spotQuoteList) return
    if (spotQuoteList.length > 0) {
      analytics.track('Loadboard / Spot Quotes / View', { count: spotQuoteList.length })
    }
    if (onChange) onChange(spotQuoteList.length)
  }, [spotQuoteList, onChange])

  if (hasError) return <SpotQuoteListRefreshBanner onRefreshList={fetchSpotQuoteList} />

  if (!spotQuoteList || spotQuoteList.length === 0) return null

  return (
    <Section title="Invitation to bid" subtitle="Spot lanes waiting for your bid">
      {spotQuoteList.map(item => (
        <SpotQuoteCard item={item} key={item.lanes.uuid} />
      ))}
    </Section>
  )
}
